import {Roles} from 'Common/permissions/Roles';
import {RolesLoader} from 'Common/permissions/RolesLoader';
import { browserId, BrowserId, BrowserOrServerId, idString} from 'Browser/BrowserId';
import Assert from 'Common/Assert';
import { isServer } from 'solid-js/web';
import type { ObjectId } from 'mongodb';
import { Role } from 'Common/config/Role';

export class User<EitherId extends BrowserOrServerId>
{
	static readonly unknownKey = 'eeeeeeeeeeeeeeeeeeeeeeee';

	constructor(
		readonly id: EitherId, 
		readonly firstName:string,
		readonly lastName:string,
		readonly email:string,
		readonly roles: Roles<EitherId>
	)
	{ }

	toJson()
	{
		/* Note that the session stores a JSON object - converting Id and Roles to JSON */

		return {
			id: this.id,
			firstName: this.firstName,
			lastName: this.lastName,
			email: this.email,
			roles: this.roles.toJson()
		};
	}

	isUnknown():boolean
	{
		return idString(this.id) == User.unknownKey;
	}

	static fromJson(json:any):User<BrowserId>
	{
		Assert.check(!isServer);

		/* Note this id is not passed through RPC, but through the Solid serialiser */
//		const id = browserId(json.id);
		const id = json.id;

		return new User(id,json.firstName,json.lastName,json.email,
			(new RolesLoader()).createRoles(json.roles)
		);
	}
}

export function convertUserIds<U extends {id:BrowserOrServerId|string, roles:Role<ObjectId>[]}>(user:U)
{
	const newRoles = user.roles.map(convertRoleIds);
	return {...user, id: browserId(user.id.toString()), roles: newRoles};
}

function convertRoleIds(role:Role<ObjectId>):Role<BrowserId>
{
	if ('artistId' in role && role.artistId)
		return {...role, artistId: browserId(role.artistId.toString())};
	if ('siteId' in role && role.siteId)
		return {...role, siteId: browserId(role.siteId.toString())};
	return role as Role<BrowserOrServerId> as Role<BrowserId>;
}

